export default "__VITE_ASSET__BYHENivK__"